import ReportsAPI from 'dashboard/api/reports';
import camelcaseKeys from 'camelcase-keys';

const defaultPage = 1;
const defaultPerPage = 25;

export const initialState = {
  records: [],
  meta: {
    page: defaultPage,
    perPage: defaultPerPage,
    total: 0,
  },
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getRecords(state) {
    return state.records;
  },
  getMeta(state) {
    return state.meta;
  },
  getUIFlags(state) {
    return state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }, params = {}) {
    commit('setUIFlags', { isFetching: true });
    try {
      const response = await ReportsAPI.getAutoAssignmentAudits({
        since: params.since,
        until: params.until,
        inboxId: params.inboxId,
        page: params.page || defaultPage,
        perPage: params.perPage || defaultPerPage,
      });
      const payload = camelcaseKeys(response.data, { deep: true });
      commit('setRecords', payload.data);
      commit('setMeta', payload.meta);
    } finally {
      commit('setUIFlags', { isFetching: false });
    }
  },
};

export const mutations = {
  setRecords(state, data) {
    state.records = data;
  },
  setMeta(state, meta) {
    state.meta = meta;
  },
  setUIFlags(state, uiFlags) {
    state.uiFlags = { ...state.uiFlags, ...uiFlags };
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
